<template>
  <div class="store_order">
    <van-nav-bar :title="title" fixed border>
      <template #left>
        <img src="../../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
    </van-nav-bar>
    <div class="collapse">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<form action="#">
				<van-search
				  v-model.trim="filterParams.no"
				  show-action
				  placeholder="请输入订单号"
				  @focus="searchFocus=true"
				  @blur="searchFocus=false"
				  @search="onRefresh"
				>
					<template #action>
						<div @click="onRefresh">搜索</div>
						<van-icon name="calendar-o" class="skin_color" @click="showOrderCalendar=true"/>
					</template>
				</van-search>
			</form>

			<van-tabs v-model="statusActive">
				<van-tab title="全部"></van-tab>
				<van-tab :title="s.name" v-for="(s, i) in orderStatus" :key="i"></van-tab>
			</van-tabs>

			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="items.length==0?('暂无 '+(filterParams.day!=''?filterParams.day:'今天')+' 的订单'):('没有更多 '+(filterParams.day!=''?filterParams.day:'今天')+' 订单了')"
			@load="loadData"
			>
				<div class="col-item" v-for="(item, index) in items" :key="index">
					<div class="msg">
						<div class="topic">
							<van-icon name="label-o" class="color_red" size="18px"/>
							<span class="title">{{item.o_no}}</span>
						</div>
						<span class="time">{{item.create_time*1000|moment_format('HH:mm:ss')}}</span>
					</div>
					<van-cell-group>
						<van-field v-model.number="item.amount_order" label="金额：" placeholder="请输入金额" v-if="item.status==0" >
							<template #button>
								元&nbsp;
								<van-button size="mini" type="primary" @click="changeOrderAmount(item,'order')">改价</van-button>
								<van-button size="mini" type="danger" @click="toShoppingManage(item)">管理</van-button>
							</template>
						</van-field> 
						<van-cell
							title="金额："
							:value="item.amount_order"
							v-else>
							<template #right-icon>
								元&nbsp;
								<van-button size="mini" type="danger" :style="{'margin-left':'5px'}" @click="toShoppingManage(item)" v-if="(item.status==1||item.status==2)&&(item.express!=-1&&item.o_address)">管理</van-button>
								<van-tag type="danger" plain size="medium" :style="{'margin-left':'5px'}" v-if="item.status==-1||item.status==-2">{{item.status==-1?"已取消":(item.status==-2?"已超时":"")}}</van-tag>
								<van-button size="mini" type="primary" :style="{'margin-left':'5px'}" @click="resetShoppingPay(item, 'repay')" v-if="item.status==-2">复单</van-button>
								<van-button size="mini" type="danger" :style="{'margin-left':'5px'}" @click="resetShoppingPay(item, 'cancel')" v-if="item.status==-2">取消</van-button>
							</template>
						</van-cell>
						<van-field v-model.number="item.amount_express" label="运费：" placeholder="请输入金额" v-if="item.status==0&&item.o_address" >
							<template #button>
								<van-button size="mini" type="primary" @click="changeOrderAmount(item,'express')">改运费</van-button>
							</template>
						</van-field> 
						<van-cell
							title="运费："
							:value="item.amount_express"
							v-else-if="item.o_address">
							<template #right-icon>
								元
							</template>
						</van-cell>
						<van-cell
							title="已优惠："
							:value="item.amount_discount"
							v-if="item.amount_discount">
							<template #right-icon>
								元
							</template>
						</van-cell>
						<van-cell
							title="备注："
							:value="item.remark"
							v-if="item.remark">
						</van-cell>

						<van-cell
							title="地址："
							:value="item.o_address"
							v-if="item.o_address">
						</van-cell>
						<van-cell
							title="联系信息："
							 label-width="100px"
							:value="item.o_picker+' , '+item.o_telphone"
							v-if="item.o_picker">
						</van-cell>
						<van-cell
							title="商家备注："
							 label-width="100px"
							:value="item.s_remark"
							v-if="item.s_remark">
						</van-cell>
						<van-cell
							title="状态："
							:value="item.status==99?'已完成':(item.status==-1?'已取消':((item.status==1||item.status==2)?('已支付'+(item.o_address?(item.express==2?'，已送达':(item.express==1?'，配送中':(item.express==0?'，待配送':''))):'')):'待支付'))">
							<template #right-icon>
								&nbsp;
								<van-button size="mini" type="info" @click="getShoppingGoodList(item.o_no,item.status)">购物单</van-button>
								<van-button size="mini" type="danger" @click="toShoppingPay(item)"  v-if="!(item.status==-1||item.status==1||item.status==99)">收款</van-button>
							</template>
						</van-cell>
						
					</van-cell-group>
				</div>
			</van-list>
		</van-pull-refresh>
    </div>

	<van-popup v-model="showShoppingGoods" position="bottom" :style="{ 'max-height': '80%' }">
		<div v-if="shoppingGoods.length>0">
			<van-card
			  :price="item.g_amount"
			  :num="item.g_num"
			  :title="item.g_name?item.g_name:'产品已下架'"
			  :thumb="attach_url+item.g_img"
			  class="van-card-small"
			  v-for="(item,index) in shoppingGoods"
			  :key="index"
			  
			>
				<template #price v-if="showShoppingOrderStatus==0&&item.g_name">
					<van-field v-model.number="item.g_amount" type="number"  class="van-card-price">
						<template #button> &nbsp;元</template>
					</van-field>
				</template>
				<template #price v-else>
					{{item.g_amount}}
				</template>
				<template #num  v-if="showShoppingOrderStatus==0&&item.g_name">
					<div class="van-card-num">
						<van-stepper v-model.number="item.g_num" :step="item.g_min_buy" integer input-width="50px"/>
						&nbsp;{{goodUnitObj[item.g_unit]}}
					</div>
				</template>
				<template #price v-else>
					{{item.g_num}}&nbsp;{{goodUnitObj[item.g_unit]}}
				</template>
				<template #footer v-if="item.g_sku">
					已选：{{item.g_sku}}
				</template>
			</van-card>
			<van-button type="primary" block @click="updateShoppingAttr()" v-if="showShoppingOrderStatus==0" :style="{'margin':'10px'}">修改</van-button>
		</div>
    	<div class="empty" v-else>
			<span class="msg">购物单空空也</span>
		</div>
    </van-popup>
	<van-popup v-model="showShoppingManage" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group>
			<van-field v-model.trim="shoppingManageInfo.remark" label="备注：" maxlength="100" placeholder="请输入备注信息" />
			
			<div v-if="shoppingManageInfo.status==0" :style="{ 'padding': '0 5px' }">
				<van-button type="primary" block @click="submitShoppingManage(1,0)"  :style="{ 'margin-bottom': '5px' }">已支付</van-button>
				<van-button type="primary" block @click="submitShoppingManage(2,0)"  :style="{ 'margin-bottom': '5px' }">货到付款</van-button>
				<van-button type="default" block @click="submitShoppingManage(-1,0)"  :style="{ 'margin-bottom': '5px' }">取消</van-button>
			</div>
			<div v-if="(shoppingManageInfo.status==1 || shoppingManageInfo.status==2)&&shoppingManageInfo.o_address&&shoppingManageInfo.o_telphone" :style="{ 'padding': '0 5px' }">
				<van-button type="primary" block @click="submitShoppingManage(1,1)" v-if="shoppingManageInfo.express!=1" :style="{ 'margin-bottom': '5px' }">配送中</van-button>
				<van-button type="primary" block @click="submitShoppingManage(1,2)" >已送达</van-button>
			</div>
			<!--van-cell
			title="支付："
			title-class="van-cell-title"
			v-if="shoppingManageInfo.status==0">
				<van-radio-group v-model="shoppingManageStatus" direction="horizontal">
					<van-radio name="1">已支付</van-radio>
					<van-radio name="2">货到付款</van-radio>
					<van-radio name="-1">取消</van-radio>
				</van-radio-group>
			</van-cell>

			<van-cell
			title="配送："
			title-class="van-cell-title"
			v-if="(shoppingManageInfo.status==1 || shoppingManageInfo.status==2)&&shoppingManageInfo.o_address&&shoppingManageInfo.o_telphone">
				<van-radio-group v-model="shoppingManageExpress" direction="horizontal">
					<van-radio name="1" v-if="shoppingManageInfo.express!=1">配送中</van-radio>
					<van-radio name="2">已送达</van-radio>
				</van-radio-group>
			</van-cell-->

		</van-cell-group>

		<!--van-button type="primary" block @click="submitShoppingManage()" >提交</van-button-->
    </van-popup>
    <van-popup v-model="showPayTypes" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group title="选择收款方式" class="pay_type_group">
			<van-radio-group v-model="payBy">
				<van-radio :name="p.values" v-for="(p,i) in payTypes" :key="i">
				{{p.describe}}
				<template #icon="props">
					<img class="pay_icon" :src="props.checked ? require('../../../assets/img/icon/pay/'+p.values+'_active.png') : require('../../../assets/img/icon/pay/'+p.values+'.png')" />
				</template>
				</van-radio>
			</van-radio-group>
			<van-button type="danger" block @click="getShoppingPayQRCode()" >生成收款码</van-button>
		</van-cell-group>
    </van-popup>

    <van-popup v-model="showPayQRCode" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center'}">
		<van-cell-group title="扫描二维码付款" class="pay_type_group">
			<div>金额：{{payQRCode.amount}}元</div>
			<vue-qr :text="payQRCode.url" :size="220" ref="Qrcode"></vue-qr>
			<div>订单号：{{payQRCode.o_no}}</div>
			<van-button type="danger" block @click="refreshByPay" >已收款</van-button>
		</van-cell-group>
    </van-popup>

	<van-calendar v-model="showOrderCalendar" @confirm="onConfirmOrderCalendar" :default-date="new Date()" :min-date="minSelectCalendar" :max-date="new Date()"/>

  </div>
</template>

<script type="text/ecmascript-6">
import { chkImgType,goodUnit } from "@/utils/common.js";
import { List, Card, Divider, Search, Stepper ,Calendar, RadioGroup, Radio} from "vant";
import vueQr from "vue-qr";

export default {
	name: "storeOrder",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-divider":Divider,
		"van-search":Search,
		"van-stepper":Stepper,
		"van-calendar":Calendar,
		"van-radio-group":RadioGroup,
		"van-radio":Radio,
		"vue-qr":vueQr
	},
	data() {
		return {
			title: "订单管理",
			attach_url:this.Conf.serverPre,
			items: [],
			goodUnits:[],
			goodUnitObj:{},
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			filterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
				status:-2,
				day:'',
				no:''
			},
			cur_s_id:-1,
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			orderStatus:[],
			orderStatusObj:{
				'0':{status:0,name:'待支付'},
				'1':{status:1,name:'已支付'},
				'2':{status:2,name:'货到付款'},
				'99':{status:99,name:'完成'},
				'-1':{status:-1,name:'已取消'}
			},
			showPicker:false,
			pickerType:-1,
			pickerValueKey:'',
			pickerColumns:[],
			pickerIndex:{},
			searchFocus:false,
			statusActive:0,
			showOrderCalendar:false,
			minSelectCalendar:new Date(),

			showShoppingOrderNo:'',
			showShoppingOrderStatus:0,
			showShoppingGoods:false,
			shoppingGoods:[],
			showShoppingManage:false,
			shoppingManageInfo:{},
			shoppingManageStatus:'1',
			shoppingManageExpress:'1',

			shoppingGoodInfo:{},
			collapseActiveName:'c_0',

			payTypes:[],
			showPayTypes:false,
			payBy:'',
			showPayQRCode:false,
			payQRCode:{}
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		this.cur_s_id = this.$route.params.s_id;
		if(!this.cur_s_id){
			this.goBack();
			return false;
		}
		this.filterParams['s_id'] = this.cur_s_id;
		this.loadData();

		this.minSelectCalendar.setMonth( this.minSelectCalendar.getMonth()-6 );
		let cols = [];
		for(var k in this.orderStatusObj){
			cols.push({key:k,name:this.orderStatusObj[k].name});
		}
		this.orderStatus = cols;
		this.getPayTypes();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = this.filterParams;
				params.page = this.page;

				var url = this.Conf.serverUrl + "UserStore/myOrder" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.orders;
						}else{
							this.items = this.items.concat(response.data.orders);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
					}
				})
				.catch(error => {});
			}, 1000);
		},
		getPayTypes(){
			var params = {
				group: 'sys_pay'
			};
			var url = this.Conf.serverUrl + "Dictionary/options" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.payTypes = response.data.dicts;
			})
			.catch(error => {});
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		onConfirmOrderCalendar(date){
			this.filterParams.day =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showOrderCalendar = false;
			this.onRefresh();
		},
		getShoppingGoodList(no,st){
			this.showShoppingOrderNo = no;
			this.showShoppingOrderStatus = st;
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id,
				o_no:no
			};
			var url = this.Conf.serverUrl + "UserStore/orderGoods" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
					return false
				}
				this.shoppingGoods = response.data.goods;
				this.showShoppingGoods = true;
			})
			.catch(error => {});
			
		},
		changeOrderAmount(item, type){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定修改"+(type=='express'?"运费":"订单价格")+"？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					o_no:item.o_no,
					type:type,
					amount:type=='express'?item.amount_express:item.amount_order
				};
				var url = this.Conf.serverUrl + "UserStore/changeOrderAmount" + "?num="+Math.random();
				let that = this;
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.onRefresh(true)
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		toShoppingManage(item){
			this.shoppingManageInfo.o_no = item.o_no;
			this.shoppingManageInfo.status = item.status;
			this.shoppingManageInfo.remark = item.s_remark;
			this.shoppingManageInfo.express = item.express;
			if(item.express==1){
				this.shoppingManageExpress = '2';
			}
			this.shoppingManageInfo.o_address = item.o_address;
			this.shoppingManageInfo.o_telphone = item.o_telphone;
			this.showShoppingManage = true;
		},
		submitShoppingManage(s,e){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定提交保存？",
			})
			.then(() => {
				this.shoppingManageInfo.m_status = s;//this.shoppingManageStatus;
				this.shoppingManageInfo.m_express = e;//this.shoppingManageExpress;
				let postData = this.shoppingManageInfo;
				postData.u_id = this.u_id;
				postData.token = this.token;
				postData.s_id = this.cur_s_id;
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/manageOrder" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(postData))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.onRefresh(true);
						that.showShoppingManage = false;
					}
				})
				.catch(error => {});

			})
			.catch((error) => {});
		},
		updateShoppingAttr(){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定提交修改？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					o_no: this.showShoppingOrderNo,
					s_id: this.cur_s_id,
					goods: this.shoppingGoods
				};
				var url = this.Conf.serverUrl + "UserStore/updateOrder" + "?num="+Math.random();
				let that = this;
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.showShoppingGoods = false;
						that.onRefresh(true)
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		toShoppingPay(item){
			this.shoppingManageInfo = item;
			this.showPayTypes = true;
			this.payBy = "";
		},
		getShoppingPayQRCode(){
			if(this.payBy == ""){
				this.$toast.fail('请选择收款方式！');
				return false;
			}
			let postData = {o_no:this.shoppingManageInfo.o_no};
			postData.u_id = this.u_id;
			postData.token = this.token;
			postData.s_id = this.cur_s_id;
			postData.pay_by = this.payBy;
			let that = this;
			var url = this.Conf.serverUrl + "UserStore/showPayQRCode" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(postData))
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.showPayTypes = false;
					that.payQRCode = response.data.data;
					that.showPayQRCode = true;
				}
			})
			.catch(error => {});
		},
		resetShoppingPay(item, type){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定"+(type=='cancel'?"取消":"恢复待支付")+"订单？",
			})
			.then(() => {
				let postData = {
					u_id: this.u_id,
					token: this.token,
					o_no:item.o_no,
					type:type
				};
				postData.s_id = this.cur_s_id;
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/manageOrder" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(postData))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.onRefresh(true);
					}
				})
				.catch(error => {});

			})
			.catch((error) => {});
		},
		refreshByPay(){
			this.showPayQRCode=false
			this.onRefresh();
		}
	},
	filters:{
		sumOrderPrice(u){
			let total = 0;
			for(var i in u.goods){
				total += u.goods[i].g_price*u.goods[i].buys
			}
			return total*100;
		}
	},
	watch:{
		statusActive(){
			this.filterParams.status = -2;
			if(this.statusActive>0){
				this.filterParams.status = this.orderStatus[this.statusActive-1].key;
			}
			this.onRefresh()
		}
	},
	beforeDestroy: function () {
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Store/StoreOrder.vue